import React from 'react'
import { Heading } from '@/components/admin/atoms/typography/Heading'
import { Text } from '@/components/admin/atoms/typography/Text'
import { ActionButton } from '@/components/admin/atoms/actions/ActionButton'
import { Inline } from '@/components/admin/atoms/layout/Inline'
import { Stack } from '@/components/admin/atoms/layout/Stack'
import { DialogShell } from '@/components/admin/atoms/layout/DialogShell'

interface ConfirmDialogProps {
  open: boolean
  title: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  onConfirm: () => void
  onCancel: () => void
  loading?: boolean
  className?: never
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open, title, description, confirmLabel = 'Delete', cancelLabel = 'Cancel',
  onConfirm, onCancel, loading = false,
}) => (
  <DialogShell open={open} onClose={onCancel}>
    <Stack gap="4">
      <Heading level={3}>{title}</Heading>
      {description && <Text size="sm" color="muted">{description}</Text>}
      <Inline gap="2" justify="end">
        <ActionButton variant="ghost" onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </ActionButton>
        <ActionButton variant="error" onClick={onConfirm} loading={loading}>
          {confirmLabel}
        </ActionButton>
      </Inline>
    </Stack>
  </DialogShell>
)
